const slider_config_type = {
  1: {
    // mousewheel: {
    //   forceToAxis: true,
    // },
    mousewheel: {
      forceToAxis: true,
      thresholdDelta: 30,
      thresholdTime: 700,
    },
    slidesPerView: "auto",
    spaceBetween: 20,
    breakpoints: {
      1: {
        spaceBetween: 8,
      },
      300: {
        spaceBetween: 8,
      },
      768: {
        spaceBetween: 20,
      },
    },
  },

  2: {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  },

  3: {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  },

  4: {
    slidesPerView: 3,
    spaceBetween: 16,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 4,
      },
    },
  },

  5: {
    slidesPerView: 3,
    spaceBetween: 16,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
      },
      768: {
        slidesPerView: 2.8,
      },
      991: {
        slidesPerView: 4,
      },
    },
  },

  6: {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    watchOverflow: true,
    breakpoints: {
      990: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  },

  7: {
    slidesPerView: 1,
    spaceBetween: 16,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  },

  8: {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
  },

  9: {
    mousewheel: true,
    slidesPerView: "auto",
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      1: {
        direction: "horizontal",
      },
      1000: {
        direction: "vertical",
      },
    },
  },
  10: {
    mousewheel: {
      forceToAxis: true,
    },
    slidesPerView:"auto",
    spaceBetween: 8,
  },
  11: {
    slidesPerView:"auto",
    spaceBetween: 24,
    mousewheel: {
      forceToAxis: true,
    },
  },
  12: {
  slidesPerView: 1.065,
  slidesPerGroup: 1,
  spaceBetween: 12,
  speed: 450,
  loop: false,
  watchOverflow: true,
  grabCursor: true,
  resistanceRatio: 0.7,
  roundLengths: true,
  observer: true,
  observeParents: true,
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    601: {
      slidesPerView: 1.5,
      spaceBetween: 16,
    },
    901: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1201: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
},

  13: {
    slidesPerView: "auto",
    spaceBetween: 24,
    freeMode: true,
    grabCursor: true,
    watchOverflow: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      700: {
        spaceBetween: 32,
      },
    },
    on: {
      init(swiper) {
        const activeIndex = swiper.slides.findIndex((slide) =>
          slide.classList.contains("is-active")
        );

        if (activeIndex > 0) {
          swiper.slideTo(activeIndex, 0);
        }
      },
    },
  },
};

class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
    this.initProductZoom();
  }

  initSlider(force = false) {
    if (this.swiper && !force) {
      this.swiper.update();
      return;
    }

    if (this.swiper && force) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (typeof Swiper === "undefined") return;

    const index = this.dataset.index || "1";
    const baseConfig = slider_config_type[index];

    if (!baseConfig) return;

    const container =
      this.closest("[data-slider-container]") ||
      this.closest(".shopify-section") ||
      this.closest("section") ||
      document;

    const nextEl =
      this.querySelector(".swiper-button-next") ||
      container.querySelector(".swiper-button-next");

    const prevEl =
      this.querySelector(".swiper-button-prev") ||
      container.querySelector(".swiper-button-prev");

    const paginationEl =
    this.querySelector(".swiper-pagination") ||
    Array.from(container.querySelectorAll(".swiper-pagination")).find(
      (el) => !el.closest("custom-slider")
    );
    const scrollbarEl =
      this.querySelector(".swiper-scrollbar") ||
      container.querySelector(".swiper-scrollbar");

    const navigation =
      nextEl && prevEl
        ? {
            navigation: {
              nextEl,
              prevEl,
            },
          }
        : {};

    const paginationType =
      this.dataset.pagination ||
      baseConfig.pagination?.type ||
      "bullets";

    const pagination = paginationEl
      ? {
          pagination: {
            ...(baseConfig.pagination || {}),
            el: paginationEl,
            type: paginationType,
            clickable: paginationType === "bullets",
          },
        }
      : {};

    const scrollbar = scrollbarEl
      ? {
          scrollbar: {
            el: scrollbarEl,
          },
        }
      : {};

    const config = {
      ...baseConfig,
      ...navigation,
      ...pagination,
      ...scrollbar,
    };

    if (this.classList.contains("swiper-main-thumb")) {
      this.initMainWithThumbs(config);
      return;
    }

    requestAnimationFrame(() => {
      if (!this.isConnected) return;

      this.swiper = new Swiper(this, config);

      requestAnimationFrame(() => {
        this.swiper?.update();
      });
    });
  }

  initMainWithThumbs(config) {
    const container =
      this.closest(".custom-media-product") ||
      this.closest(".section-thumbnail-slider__wrap") ||
      this.closest(".shopify-section");

    const thumbSlider = container?.querySelector(
      "custom-slider.swiper-thumb"
    );

    const createMainSlider = () => {
      if (!this.isConnected || this.swiper) return;

      this.swiper = new Swiper(this, {
        ...config,

        ...(thumbSlider?.swiper
          ? {
              thumbs: {
                swiper: thumbSlider.swiper,
                autoScrollOffset: 1,
              },
            }
          : {}),
      });

      this.initProductZoom();
    };

    if (!thumbSlider) {
      requestAnimationFrame(createMainSlider);
      return;
    }

    const waitForThumbSlider = () => {
      if (!this.isConnected) return;

      if (!thumbSlider.swiper) {
        requestAnimationFrame(waitForThumbSlider);
        return;
      }

      createMainSlider();
    };

    waitForThumbSlider();
  }

  initProductZoom() {
    if (!this.classList.contains("swiper-main-thumb")) return;
    if (this.productZoomInitialized) return;

    const button = this.querySelector(".custom-product-zoom-button");

    if (!button) return;

    this.productZoomInitialized = true;

    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      await customElements.whenDefined("product-gallery");

      const productGallery =
        this.closest("product-gallery") ||
        this.closest(".shopify-section")?.querySelector("product-gallery");

      if (!productGallery) {
        console.error("Product gallery not found");
        return;
      }

      if (typeof productGallery.openZoom !== "function") {
        console.error("productGallery.openZoom is not available", productGallery);
        return;
      }

      const activeSlide =
        this.querySelector(".swiper-slide-active") ||
        this.swiper?.slides?.[this.swiper.activeIndex];

      if (!activeSlide) {
        console.error("Active Swiper slide not found");
        return;
      }

      if (activeSlide.dataset.mediaType !== "image") return;

      const imageSlides = Array.from(
        this.querySelectorAll(
          '.product-gallery__media[data-media-type="image"]:not([hidden])'
        )
      );

      const openIndex = imageSlides.indexOf(activeSlide);

      if (openIndex === -1) {
        console.error("Active slide is missing from zoom images");
        return;
      }

      productGallery.openZoom(openIndex);
    });
  }

  refreshSlider() {
    this.initSlider(true);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.productZoomInitialized = false;
  }
}

if (!customElements.get("custom-slider")) {
  customElements.define("custom-slider", CustomSlider);
}